import { FiCalendar, FiChevronsDown, FiSearch, FiTag } from "react-icons/fi";

import { PillButton } from "@/components/ds";

export interface TransactionsToolbarPill {
  /** Texto visible del botón. */
  text: string;
  /** Nombre accesible completo del botón. */
  label: string;
  /** Estado del desplegable asociado (se reenvía como aria-expanded). */
  expanded?: boolean;
  onClick(): void;
}

export interface TransactionsToolbarProps {
  ariaLabel: string;
  search: string;
  onSearchChange(value: string): void;
  searchPlaceholder: string;
  cycle: TransactionsToolbarPill;
  filters: TransactionsToolbarPill & {
    /** Filtros activos: muestra la píldora amarilla con el número cuando es mayor que 0. */
    count: number;
  };
  sort: TransactionsToolbarPill;
}

/** Barra de herramientas a todo el ancho: búsqueda | Ciclo | Filtros | Ordenar. */
export function TransactionsToolbar({ ariaLabel, search, onSearchChange, searchPlaceholder, cycle, filters, sort }: TransactionsToolbarProps) {
  return (
    <div role="toolbar" aria-label={ariaLabel} className="flex w-full items-center gap-3">
      <div className="relative min-w-0 flex-1">
        <FiSearch aria-hidden="true" className="pointer-events-none absolute left-4 top-1/2 size-5 -translate-y-1/2 text-[var(--ds-ink-muted)]" />
        <input
          type="search"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={searchPlaceholder}
          aria-label={searchPlaceholder}
          className="app-focus-ring h-13 w-full rounded-[var(--ds-radius-md)] border-[1.5px] border-solid border-[var(--ds-ink-muted)] bg-[var(--ds-surface-raised)] pl-12 pr-4 text-base text-[var(--ds-ink)] outline-none placeholder:text-[var(--ds-ink-muted)]"
        />
      </div>
      <PillButton className="app-focus-ring" icon={<FiCalendar aria-hidden="true" className="size-[18px]" />} chevron aria-label={cycle.label} aria-expanded={cycle.expanded} onClick={cycle.onClick}>
        {cycle.text}
      </PillButton>
      <PillButton className="app-focus-ring" icon={<FiTag aria-hidden="true" className="size-[18px]" />} chevron count={filters.count} aria-label={filters.label} aria-expanded={filters.expanded} onClick={filters.onClick}>
        {filters.text}
      </PillButton>
      <PillButton className="app-focus-ring" icon={<FiChevronsDown aria-hidden="true" className="size-[18px]" />} aria-label={sort.label} aria-haspopup="menu" aria-controls="transactions-sort-menu" aria-expanded={sort.expanded} onClick={sort.onClick}>
        {sort.text}
      </PillButton>
    </div>
  );
}
